import { requestBaseURL } from '@/config/api';

export type AppEnv =
  | 'dev'
  | 'testing'
  | 'testing-zy'
  | 'testing-zy-v2'
  | 'staging1'
  | 'staging2'
  | 'prod1'
  | 'prod2'
  | 'unknown';

const KNOWN_APP_ENVS = [
  'dev',
  'testing',
  'testing-zy',
  'testing-zy-v2',
  'staging1',
  'staging2',
  'prod1',
  'prod2',
] as const;

type KnownAppEnv = (typeof KNOWN_APP_ENVS)[number];

const ENV_MAP: Record<string, AppEnv> = {
  'http://localhost:18300': 'dev',
  'https://api.tlc-testing.benaimed.com': 'testing',
  'https://api.tlc-testing-zy.benaimed.com': 'testing-zy',
  'https://api.tlc-testing-zy-v2.benaimed.com': 'testing-zy-v2',
  'https://api.tlc-staging.benaimed.com': 'staging1',
  'https://api.tlc-staging-v2.benaimed.com': 'staging2',
  'https://api.tlc.benaimed.com': 'prod1',
  'https://api.tlc-v2.benaimed.com': 'prod2',
};

function isKnownAppEnv(value: string | undefined): value is KnownAppEnv {
  return !!value && (KNOWN_APP_ENVS as readonly string[]).includes(value);
}

function readBuildEnv(): string | undefined {
  if (typeof process !== 'undefined' && process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }
  const globalEnv = (globalThis as { REACT_APP_ENV?: unknown }).REACT_APP_ENV;
  if (typeof globalEnv === 'string') {
    return globalEnv;
  }
  return undefined;
}

export function getAppEnv(): AppEnv {
  const buildEnv = readBuildEnv();
  if (isKnownAppEnv(buildEnv)) return buildEnv;
  return ENV_MAP[requestBaseURL] ?? 'unknown';
}

export function isProdEnv(): boolean {
  const env = getAppEnv();
  return env === 'prod1' || env === 'prod2';
}
